module.exports = __webpack_public_path__ + "img/编组 3@2x.caa78eb2.png";